import { defaultStoreNumber } from '@/lib/constants/store';
import { setOrderFulfillment } from '@/lib/functions/setOrderFulfillment';

import type { OrderActions } from '@/lib/context/orderActions';
import type { OrderPayload } from '@/lib/types/orderPayload';
import type { OrderState } from '@/lib/types/orderState';

/** Party Supplies is shipping-only from a single store (default: 91). */
const PARTY_FULFILLMENT_METHOD = 'shipping' as const;
const PARTY_FULFILLMENT_STORE = defaultStoreNumber;

/**
 * Ensures the Sylius order has shipping fulfillment for the party store.
 * @returns true when fulfillment was updated and the cart should be re-fetched.
 */
export async function ensurePartyOrderFulfillment(
  orderState: OrderState,
  orderDispatch: React.Dispatch<OrderActions>,
  fetched: OrderPayload | null,
): Promise<boolean> {
  if (!fetched || !orderState.token) {
    return false;
  }

  const currentMethod = fetched.fulfillment?.method;
  const currentStoreNumber = fetched.fulfillment?.store?.number;
  const needsCreate = !fetched.fulfillment;
  const methodMismatch = currentMethod !== PARTY_FULFILLMENT_METHOD;
  const storeMismatch = Number(currentStoreNumber) !== PARTY_FULFILLMENT_STORE;

  if (!needsCreate && !methodMismatch && !storeMismatch) {
    return false;
  }

  const resp = await setOrderFulfillment(
    orderState.token,
    orderState.tokenType,
    orderState,
    orderDispatch,
    PARTY_FULFILLMENT_METHOD,
    PARTY_FULFILLMENT_STORE,
  );

  return resp.success;
}
